/// <amd-module name="Feed/Legacy/Protocols/Ivy/Commands/IvyPromoteCommand" />
import { IVssPageContext } from "VSS/Platform/Context";

import { Package, PackageVersion } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import * as Actions from "Feed/Legacy/Actions/Actions";
import { ProtocolCommands } from "Feed/Legacy/Common/ProtocolCommands";
import { IPackageCommand } from "Feed/Legacy/Types/IPackageCommand";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class IvyPromoteCommand implements IPackageCommand {
    public readonly id: string;
    public readonly protocolCommand: ProtocolCommands;
    public readonly displayText: string;
    public readonly titleText: string;
    public readonly icon: string;
    public readonly inFeedContextMenu: boolean; // TODO: Remove - not used
    public readonly inPackageContextMenu: boolean; // TODO: Remove - not used
    public readonly actionMethod: () => void;

    constructor(
        pageContext: IVssPageContext,
        packageSummary: Package,
        packageVersion: PackageVersion,
        feed: Feed,
        viaPackageList: boolean
    ) {
        this.id = "promote";
        this.protocolCommand = ProtocolCommands.Promote;
        this.displayText = PackageResources.PackageCommands_PromotePackage;
        this.icon = "bowtie-icon bowtie-arrow-up cta";
        this.inFeedContextMenu = true;
        this.inPackageContextMenu = true;
        this.actionMethod = () => {
            Actions.IvyPromotePanelOpened.invoke({ packageSummary, packageVersion });
        };
    }
}
